<template>
  <div
    class="content_header align-items-stretch justify-content-center d-md-flex"
    :class="{
      'd-none': $route.name == '首頁',
      'd-md-flex': $route.name == '首頁'
    }"
  >
    <div
      class="col content_header_image d-none d-lg-flex"
      style="background-image:url('/img/platform_header.png');"
    ></div>
    <div class="col-auto">
      <div class="row" v-if="$route.name == '首頁'">
        <div class="py-3 px-1 col-auto" style="min-width: 166px">
          <v-select
            label="name"
            :reduce="type => type.value"
            :options="type_list"
            v-model="filter_condition.type"
            placeholder="請選擇動力類型"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"
                ><b-icon icon="chevron-down"></b-icon
              ></span>
            </template>
          </v-select>
        </div>
        <div class="py-3 px-1 col-auto" style="min-width: 130px">
          <v-select
            label="name"
            :reduce="brand => brand.id"
            :options="brand_list"
            v-model="filter_condition.brand"
            placeholder="請選擇品牌"
            :disabled="!brand_list.length && new Boolean(filter_condition.type)"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"
                ><b-icon icon="chevron-down"></b-icon
              ></span>
            </template>
          </v-select>
        </div>
        <div class="py-3 px-1 col-auto" style="min-width: 130px">
          <v-select
            label="name"
            :reduce="model => model.id"
            :options="model_list"
            v-model="filter_condition.model"
            placeholder="請選擇車款"
            :disabled="!model_list.length"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"
                ><b-icon icon="chevron-down"></b-icon
              ></span>
            </template>
          </v-select>
        </div>
        <div class="py-3 px-1 col-auto" style="min-width: 178px">
          <v-select
            label="publish_year"
            :reduce="year => year.id"
            :options="year_list"
            v-model="filter_condition.year"
            placeholder="請選擇年份/c.c.數"
            :disabled="!year_list.length"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"
                ><b-icon icon="chevron-down"></b-icon
              ></span>
            </template>
          </v-select>
        </div>
        <div class="col-auto content_header_button">
          <b-button class="py-3" @click="searchProduct">快速搜尋</b-button>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-auto px-3 header-title">
          {{ $route.name }}
        </div>
      </div>
    </div>
    <div class="col content_header_right d-none d-lg-flex"></div>
  </div>
</template>
<style lang="scss">
.content_header {
  background-color: $platform_main;
  color: #fff;
  &_right {
    background-color: #2d2f30;
    // padding-left: 64px;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      transform: translateX(-100%);
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 64px 64px;
      border-color: transparent transparent #2d2f30 transparent;
    }
    // &::before {
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 0;
    //   height: 0;
    //   border-style: solid;
    //   border-width: 64px 64px 0 0;
    //   border-color: $platform_main transparent transparent transparent;
    // }
  }
  &_button {
    position: relative;
    padding: 0 64px;
    button {
      height: 100%;
      background-color: #82151a;
      border-radius: 0;
      border: none;
      padding-right: 0;
      padding-left: 0;
      &:hover,
      &:focus,
      &:active {
        background-color: #82151a !important;
        box-shadow: none !important;
      }
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 64px 64px;
      border-color: transparent transparent #82151a transparent;
    }
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 64px 64px 0 0;
      border-color: #82151a transparent transparent transparent;
    }
  }
  &_image {
    background-repeat: no-repeat;
    background-position: right center;
    position: relative;
    background-size: cover;
    padding-right: 100px;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 64px 64px;
      border-color: transparent transparent $platform_main transparent;
    }
  }
  .vs__clear {
    fill: rgb(255 255 255 / 50%);
  }
  .vs__search,
  .vs__selected {
    &,
    &:focus {
      color: #fff;
    }
  }
  .vs__dropdown-toggle {
    border: none;
  }
  .vs--disabled {
    opacity: 0.5;
    .vs__clear,
    .vs__dropdown-toggle,
    .vs__open-indicator,
    .vs__search,
    .vs__selected {
      background-color: transparent;
    }
  }
  .vs__dropdown-option--highlight {
    background-color: $platform_main;
  }
}
.header-title {
  font-size: 24px;
  min-width: 796px;
  line-height: 64px;
  @include media-breakpoint-down(sm) {
    min-width: auto;
    font-size: 18px;
  }
}
</style>
<script>
import { Data } from "@/assets/api/platform.js";
import { Toast } from "@/plugins/sweetalert2.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "contentHeader",
  props: ["token"],
  components: { vSelect },
  data() {
    return {
      type_list: [
        {
          name: "汽油車",
          value: "gas"
        },
        {
          name: "油電車",
          value: "hybrid"
        },
        {
          name: "電動車",
          value: "electric"
        },
        {
          name: "柴油車",
          value: "diesel"
        }
      ],
      brand_list: [],
      model_list: [],
      year_list: [],
      category_list: [],
      all_year_list: [],
      filter_condition: {
        type: "",
        brand: "",
        model: "",
        year: "",
        displacing: ""
      }
    };
  },
  watch: {
    "filter_condition.type": function(val) {
      this.brand_list = [];
      this.model_list = [];
      this.year_list = [];
      this.filter_condition.brand = "";
      this.filter_condition.model = "";
      this.filter_condition.year = "";
      if (val) {
        this.brand_list = [];
        this.all_year_list.forEach(year => {
          if (year.type == val) {
            const name = this.getBrandName(year.car_brand_id);
            if (this.brand_list.length) {
              for (let index = 0; index < this.brand_list.length; index++) {
                if (this.brand_list[index].id == year.car_brand_id) return;
              }
            }
            this.brand_list.push({
              id: year.car_brand_id,
              name: name
            });
          }
        });
      } else {
        this.getBrand();
      }
    },
    "filter_condition.brand": function(val) {
      this.model_list = [];
      this.year_list = [];
      this.filter_condition.model = "";
      this.filter_condition.year = "";
      if (val && !this.filter_condition.type) {
        Data.model(this.filter_condition.brand, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.model_list = res.data;
            } else {
              Toast.fire({
                icon: "error",
                title: "汽車型號資料讀取失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        this.all_year_list.forEach(year => {
          if (
            year.type == this.filter_condition.type &&
            year.car_brand_id == val
          ) {
            const name = this.getModelName(year.car_model_id);
            if (this.model_list.length) {
              for (let index = 0; index < this.model_list.length; index++) {
                if (this.model_list[index].id == year.car_model_id) return;
              }
            }
            this.model_list.push({
              id: year.car_model_id,
              name: name
            });
          }
        });
      }
    },
    "filter_condition.model": function(val) {
      this.year_list = [];
      this.filter_condition.year = "";
      if (val && !this.filter_condition.type) {
        Data.type(
          this.filter_condition.brand,
          this.filter_condition.model,
          this.token
        )
          .then(res => {
            if (res.status <= 201) {
              res.data.forEach(val => {
                this.year_list.push({
                  id: val.id,
                  publish_year:
                    val.publish_year + " / " + val.displacing + "c.c."
                });
              });
            } else {
              Toast.fire({
                icon: "error",
                title: "汽車年份資料讀取失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        this.all_year_list.forEach(year => {
          if (
            year.type == this.filter_condition.type &&
            year.car_brand_id == this.filter_condition.brand &&
            year.car_model_id == val
          ) {
            if (this.year_list.length) {
              for (let index = 0; index < this.year_list.length; index++) {
                if (this.year_list[index].id == year.id) return;
              }
            }
            this.year_list.push({
              id: year.id,
              publish_year: year.publish_year + " / " + year.displacing + "c.c."
            });
          }
        });
      }
    }
  },
  created() {
    this.getBrand();
    Data.category()
      .then(res => {
        if (res.status <= 201) {
          this.category_list = res.data.data;
          res.data.data.forEach(brand => {
            brand.models.forEach(model => {
              model.years.forEach(year => {
                this.all_year_list.push(year);
              });
            });
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "完整汽車資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    getBrand() {
      Data.brand(this.token)
        .then(res => {
          if (res.status <= 201) {
            this.brand_list = res.data;
          } else {
            Toast.fire({
              icon: "error",
              title: "汽車品牌資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getBrandName(id) {
      for (let index = 0; index < this.category_list.length; index++) {
        if (this.category_list[index].id == id) {
          return this.category_list[index].name;
        }
      }
    },
    getModelName(id) {
      for (let index = 0; index < this.category_list.length; index++) {
        for (let i = 0; i < this.category_list[index].models.length; i++) {
          if (this.category_list[index].models[i].id == id) {
            return this.category_list[index].models[i].name;
          }
        }
      }
    },
    searchProduct() {
      this.$emit("searchProduct", this.filter_condition);
    }
  }
};
</script>
